export const PEERTUBE_IN_PROGRESS = ['queued', 'uploading', 'processing'];
export const AI_BRIEF_IN_PROGRESS = ['waiting_captions', 'generating'];

export const peertubeStatusLabel = (status) => {
  switch (status) {
    case 'queued':
      return 'В очереди на PeerTube';
    case 'uploading':
      return 'Загрузка в PeerTube';
    case 'processing':
      return 'Обработка на PeerTube';
    case 'ready':
      return 'PeerTube';
    case 'error':
      return 'Ошибка PeerTube';
    default:
      return '';
  }
};

export const aiBriefStatusLabel = (status) => {
  switch (status) {
    case 'waiting_captions':
      return 'Ждём субтитры PeerTube';
    case 'generating':
      return 'ИИ заполняет карточку';
    case 'ready':
      return 'Карточка заполнена ИИ';
    case 'error':
      return 'Ошибка автозаполнения';
    default:
      return '';
  }
};

export const isPeertubeInProgress = (status) => PEERTUBE_IN_PROGRESS.includes(status);
export const isAiBriefInProgress = (status) => AI_BRIEF_IN_PROGRESS.includes(status);
